import { loggerService } from './logger';
import { LegacyLogger } from './legacy-logger';
import PACKAGE from '../../package.json';
global.logger = new LegacyLogger(loggerService.getRoot());
global.VERSION = PACKAGE.version;
